<template>
	<div
		class="event-center-empty-state"
		role="status"
	>
		<Icon
			class="event-center-empty-state__icon"
			:icon-name="content.icon"
			size="xxxxl"
			aria-hidden="true"
		/>
		<h2 class="event-center-empty-state__title">
			{{ content.title }}
		</h2>
		<p class="event-center-empty-state__text">
			{{ content.text }}
		</p>
	</div>
</template>

<script>
import Icon from '@shared/components/Icon';

const variants = ['default', 'filtered', 'upcoming', 'replays'];

export default {
	name:       'EventCenterEmptyState',
	components: { Icon },
	props:      {
		variant: {
			type:      String,
			default:   'default',
			validator: variant => variants.includes(variant),
		},
	},
	computed: {
		content() {
			const contentByVariant = {
				filtered: {
					icon:  'search',
					title: this.$I18n.trans('event_center.empty_state.filtered_title'),
					text:  this.$I18n.trans('event_center.empty_state.filtered_text'),
				},
				upcoming: {
					icon:  'calendar-event',
					title: this.$I18n.trans('event_center.empty_state.upcoming_title'),
					text:  this.$I18n.trans('event_center.empty_state.upcoming_text'),
				},
				replays: {
					icon:  'replay',
					title: this.$I18n.trans('event_center.empty_state.replays_title'),
					text:  this.$I18n.trans('event_center.empty_state.replays_text'),
				},
				default: {
					icon:  'calendar-event',
					title: this.$I18n.trans('event_center.empty_state.default_title'),
					text:  this.$I18n.trans('event_center.empty_state.default_text'),
				},
			};

			return contentByVariant[this.variant];
		},
	},
};
</script>

<style lang="scss" scoped>
@import '@sass/variables';

.event-center-empty-state {
	display: flex;
	min-height: 360px;
	padding-right: $sp5;
	padding-left: $sp5;
	color: var(--color-grey-400);
	align-items: center;
	flex-direction: column;
	justify-content: center;
	text-align: center;

	@include size(md-up) {
		min-height: 480px;
	}
}

.event-center-empty-state__title {
	@include font(primary, book, normal, fs-170);
	margin-bottom: $sp3;
	color: var(--color-white);

	body.-t-light & { // stylelint-disable-line selector-no-qualifying-type
		color: var(--color-black);
	}
}

.event-center-empty-state__icon {
	margin-bottom: $sp6;
}

.event-center-empty-state__text {
	@include font(primary, book, normal, fs-100);
	max-width: 560px;
	margin-bottom: 0;
}
</style>
